import { PlayFill } from '@styled-icons/bootstrap/PlayFill'
import { useEffect, useState } from 'react'
import { animated, useTrail } from 'react-spring'
import styled from 'styled-components'

//* ============================= Types =======================================

type SkipArrowAnimationProps = {
  seconds: number
}

//* ============================= React Component =======================================

const SkipArrowAnimation = ({ seconds }: SkipArrowAnimationProps): JSX.Element => {
  const [opacity, setOpacity] = useState(0)
  const [scale, setScale] = useState(1)

  const trail = useTrail(3, {
    opacity: opacity,
    scale: scale,
    config: {
      duration: 110,
    },
  })

  // When the skipping begins, and therefore the seconds change, then the animation should start
  // by setting the max values.
  // The animation ends by setting the min values. These are set as soon as the skipping ends, cause
  // then the seconds change to 0.
  useEffect(() => {
    if (seconds != 0) {
      // Max values
      setOpacity(1)
      setScale(1.2)
    } else {
      // Min values
      setOpacity(0)
      setScale(1)
    }
  }, [seconds])

  return (
    <Row>
      {trail.map((props, index) => {
        return <AnimatedArrow style={props} key={index} />
      })}
    </Row>
  )
}

export default SkipArrowAnimation

//* ============================= Styled Components =======================================

const Row = styled.div`
  display: flex;
  flex-direction: row;
`

const Arrow = styled(PlayFill)`
  width: 30px;
  color: white;
`

const AnimatedArrow = animated(Arrow)
